import { BRAND_NAME } from "../../lib/brand";
// app/src/modules/ui/Brand.tsx — renders the Slough Scooters logo image.
// Single source of truth for the brand mark. Props kept compatible with
// prior callers so no surrounding changes are needed.
//
// Two artwork files, not a CSS filter: `logo.png` is black ink + brand red for
// light surfaces, `logo-ondark.png` is white ink with the SAME brand red for
// dark surfaces. The old `brightness(0) invert(1)` filter flattened everything
// to pure white and destroyed the red swoosh and the SCOOTERS underline.
// Both are rendered and CSS shows the right one, so there is no theme flash and
// no reliance on `content: url()` support.

interface BrandLockupProps {
  size?: number;            // height in px (default 40)
  fontSize?: number;        // (kept for API compat — unused)
  color?: string;           // (kept for API compat — unused)
  gap?: number;             // (kept for API compat — unused)
  showText?: boolean;       // (kept for API compat — unused)
  direction?: "row" | "column"; // (kept for API compat — unused)
  className?: string;
  /** Force the light-ink artwork — for permanently dark surfaces (loader, till rail). */
  invert?: boolean;
}

export default function BrandLockup({ size = 40, className, invert }: BrandLockupProps) {
  // `display` deliberately lives in CSS (.brand-logo / -light / -dark), not here:
  // an inline display would outrank the theme rules that pick the variant.
  const style: React.CSSProperties = { height: size, width: "auto" };
  const cls = (variant: string) => ["brand-logo", `brand-logo-${variant}`, className].filter(Boolean).join(" ");
  if (invert) return <img src="/brand/logo-ondark.png" alt={BRAND_NAME} className={["brand-logo", className].filter(Boolean).join(" ")} style={style} />;
  return (
    <>
      <img src="/brand/logo.png" alt={BRAND_NAME} className={cls("light")} style={style} />
      <img src="/brand/logo-ondark.png" alt="" aria-hidden className={cls("dark")} style={style} />
    </>
  );
}
